import { useEffect } from "react";
import { Link } from "react-router-dom";
import DesignPortfolio from "../components/DesignPortfolio";
import "../styles/Portfolio.css";

const Portfolio = () => {
  useEffect(() => {
    if (!window.location.hash) return;

    const target = document.querySelector(window.location.hash);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  const techCaseStudies = [
    {
      title: "Founder-Level CTO Leadership",
      context: "Techstars-backed travel startup",
      summary:
        "Owned early technical direction across product strategy, architecture, rebuild planning, investor readiness, and zero-to-one delivery decisions.",
      strengths: [
        "MVP sequencing",
        "Frontend and backend rebuilds",
        "Technical roadmap clarity",
        "Founder and investor support",
      ],
    },
    {
      title: "Head of Engineering Support",
      context: "Production platform leadership",
      summary:
        "Led engineering strategy, backend systems, delivery process, and team direction while balancing speed with long-term maintainability.",
      strengths: [
        "Engineering process",
        "Backend systems",
        "Reliability planning",
        "Team structure",
      ],
    },
    {
      title: "Senior Product Engineering",
      context: "Contract and product teams",
      summary:
        "Built and supported web systems across frontend, backend, cloud, CI/CD, observability, and security-sensitive product decisions.",
      strengths: [
        "React delivery",
        "Node/TypeScript APIs",
        "Cloud foundations",
        "Observability and risk review",
      ],
    },
  ];

  const techSkills = [
    "Product strategy",
    "MVP planning",
    "System architecture",
    "React",
    "Node/TypeScript",
    "APIs",
    "Cloud foundations",
    "CI/CD",
    "Observability",
    "Security review",
    "Engineering leadership",
    "Hiring and team process",
  ];

  return (
    <div className="portfolio-page-container">
      <section className="portfolio-header">
        <p className="portfolio-kicker">Resume + portfolio</p>
        <h1>Portfolio</h1>
        <p>
          A combined view of my technical leadership, product engineering, and
          fashion design work for companies, founders, collaborators, and
          clients reviewing me for contracts or commissions.
        </p>
        <div className="portfolio-header-actions">
          <a href="#tech" className="portfolio-action primary">
            Tech Work
          </a>
          <a href="#fashion" className="portfolio-action secondary">
            Fashion Work
          </a>
          <a
            href="/Britney_Epps_Contract_Technical_Resume.pdf"
            download
            className="portfolio-action secondary"
          >
            Download Resume
          </a>
          <a
            href="https://www.showbothrows.com"
            target="_blank"
            rel="noopener noreferrer"
            className="portfolio-action secondary"
          >
            ShowBothRows.com
          </a>
        </div>
      </section>

      <section className="portfolio-section" id="tech">
        <div className="portfolio-section-heading">
          <p className="portfolio-kicker">Tech contracts</p>
          <h2>Technical leadership and product engineering</h2>
          <p>
            I work best with founders and teams who need clarity, architecture,
            delivery support, and senior engineering judgment without adding
            unnecessary process.
          </p>
        </div>

        <div className="tech-card-grid">
          {techCaseStudies.map((caseStudy) => (
            <article key={caseStudy.title} className="tech-card">
              <p className="tech-context">{caseStudy.context}</p>
              <h3>{caseStudy.title}</h3>
              <p>{caseStudy.summary}</p>
              <div className="tech-strengths">
                {caseStudy.strengths.map((strength) => (
                  <span key={strength}>{strength}</span>
                ))}
              </div>
            </article>
          ))}
        </div>

        <div className="tech-snapshot">
          <div>
            <h3>Contract Fit</h3>
            <ul>
              <li>Scoped product engineering contracts</li>
              <li>Architecture and system design reviews</li>
              <li>MVP planning and technical roadmap support</li>
              <li>Founder advisory and engineering leadership coverage</li>
            </ul>
          </div>
          <div>
            <h3>Skills Snapshot</h3>
            <div className="skill-chip-grid">
              {techSkills.map((skill) => (
                <span key={skill}>{skill}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="portfolio-cta-band">
          <div>
            <h3>Reviewing me for a tech contract?</h3>
            <p>
              Start with the services page for engagement types, then email me
              with the project goal, timeline, team context, and constraints.
            </p>
          </div>
          <div className="portfolio-cta-actions">
            <Link to="/services" className="portfolio-action primary">
              View Services
            </Link>
            <Link to="/contact" className="portfolio-action secondary">
              Contact Me
            </Link>
            <a
              href="/Britney_Epps_Contract_Technical_Resume.pdf"
              download
              className="portfolio-action secondary"
            >
              Download Resume
            </a>
          </div>
        </div>
      </section>

      <section className="portfolio-section both-rows-section">
        <div>
          <p className="portfolio-kicker">Fashion brand</p>
          <h2>Both Rows</h2>
          <p>
            Both Rows is where I publish more of my design world: sustainable
            pieces, one-of-one garments, storytelling, and the evolving body of
            fashion work around the brand.
          </p>
        </div>
        <a
          href="https://www.showbothrows.com"
          target="_blank"
          rel="noopener noreferrer"
          className="portfolio-action primary"
        >
          See More Work
        </a>
      </section>

      <div className="portfolio-content" id="fashion">
        <DesignPortfolio />
      </div>
    </div>
  );
};

export default Portfolio;
